import {Controller, useFormContext} from 'react-hook-form';
import AppTextInput from '../../../../../../components/common/AppTextInput';
import {AnnouncementFormValues} from '../types';
import {SVG} from '../../../../../../constants/assetLists';

function Description() {
  const {
    control,
    watch,
    formState: {errors},
  } = useFormContext<AnnouncementFormValues>();

  return (
    <Controller
      control={control}
      name="description"
      render={({field}) => {
        const announcementType = watch('announcementType');
        const backgroundColor =
          announcementType === 'Error'
            ? '#E520554D'
            : announcementType === 'Administration'
            ? '#FFE797'
            : '#1D1B2014';

        return (
          <AppTextInput
            placeholder="הוספת תיאור"
            multiline
            rows={4}
            startIcon={
              <img
                src={SVG.descriptionDarkIcon}
                alt="icon"
                className="w-[16px] h-[14px] object-contain"
              />
            }
            className="border-none"
            style={{
              backgroundColor: backgroundColor,
            }}
            {...field}
            error={errors.description?.message}
          />
        );
      }}
    />
  );
}

export default Description;
